import { createFileRoute, Navigate, useParams } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/(protected)/workspaces/$workspaceId/employee-center/acknowledgments',
)({
  component: AcknowledgmentsRedirect,
})

export function AcknowledgmentsRedirect() {
  const { workspaceId } = useParams({ strict: false }) as {
    workspaceId: string
  }

  return (
    <Navigate
      to='/workspaces/$workspaceId/employee-center/pending-policies'
      params={{ workspaceId }}
      replace
    />
  )
}
